import React from 'react';
import bossAIPng from '../img/BOSS-AI.png';

const BossDialog = ({ title, children, onClose, width = 'auto', height = 'auto', closeIcon = true, zIndex = 99, style = {}, showHeader = true, showBossAIIcon = false, overlayClassName = '', overlayStyle = {} }) => {
  return (
    <div className={`boss-dialog-overlay ${overlayClassName}`} style={{ zIndex: zIndex, ...overlayStyle }}>
      <div className="boss-dialog" style={{ width, height, zIndex: zIndex + 1, ...style }}>
        {showHeader && <div className="boss-dialog-header">
          {showBossAIIcon && <img src={bossAIPng} alt="Boss AI" style={{ width: "25px", height: "25px" }} />}
          <span className="boss-dialog-title pl-2">{title}</span>
          {closeIcon && <button className="boss-dialog-close" onClick={onClose}>
            &times;
          </button>}
        </div>}
        <div className="boss-dialog-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default BossDialog;
